<template>
    <div>
        <el-button @click="handleShowIssuedTickets">ISSUED TICKETS</el-button>
        <el-button @click="handleOnBoardSalesReport">REPORT</el-button>

        <el-drawer title="" :visible.sync="show_issued_tickets" direction="btt" :before-close="handleClose" size="90%"
            :append-to-body="true" :destroy-on-close="true">
            <IssuedTicketsList :booking="booking"></IssuedTicketsList>
        </el-drawer>

        <el-drawer title="" :visible.sync="showPdf" direction="btt" :before-close="handleClose" size="90%"
            :append-to-body="true" :destroy-on-close="true">
            <TicketPdfViewer :url="url" v-if="url" @print="handleClose()"></TicketPdfViewer>
        </el-drawer>
    </div>
</template>

<script>
import IssuedTicketsList from './IssuedTicketsList.vue';

import {
    Report
} from '@/resources/report'
import TicketPdfViewer from '../../Ticketing/TicketPdfViewer.vue'

export default {
  components: { IssuedTicketsList, TicketPdfViewer },
  props: ['booking'],
  data() {
    return {
      show_issued_tickets: false,
      showPdf: false,
      url: null
    }
  },
  created: function () {
  
  },
  methods: {
    handleShowIssuedTickets() {      
        this.show_issued_tickets = true
    },
    handleClose() {
        this.show_issued_tickets = false
        this.showPdf = false
    },
    handleOnBoardSalesReport(){
        this.$loading = true
        let form = {
            booking_id: this.booking.id
        }
      Report.getOnBoardSalesReport(form)
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Report has been generated',
          });
          this.url = result.data.url
          this.showPdf = true
        })
        .catch(error => {
        }).finally(() => {
          this.$loading = false
        })
    }
  }
}
</script>

<style lang="scss"></style>
